import React from "react";

import { SafeArgonButton } from "0.Mine/4.Argon/ArgonComponents";

interface AddAnotherBusinessOnboardingProps {
  startFromScratch: () => void;
  importFromPrevious: () => void;
}

const AddAnotherBusinessOnboarding = ({
  startFromScratch,
  importFromPrevious,
}: AddAnotherBusinessOnboardingProps) => {
  return (
    <>
      {/*<SafeArgonButton onClick={startFromScratch}>Start from scratch</SafeArgonButton>*/}
      <SafeArgonButton onClick={importFromPrevious}>
        Importa dal business precedente
      </SafeArgonButton>
    </>
  );
};

export default AddAnotherBusinessOnboarding;
